const TOKEN_KEY = "authToken";
const REFRESH_TOKEN_KEY = "refreshToken";       // NEW
const USER_KEY = "user";

export const tokenStorage = {
  // Access token
  saveToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  // Refresh token — NEW
  saveRefreshToken: (token) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  },

  getRefreshToken: () => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  // Convenience — save both at once (matches Android's saveTokens pattern)
  saveTokens: (accessToken, refreshToken) => {
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  // User
  saveUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  getUser: () => {
    const user = localStorage.getItem(USER_KEY);
    return user ? JSON.parse(user) : null;
  },

  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);     // NEW — clear refresh too
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem("sessionStart");
  },

  isLoggedIn: () => !!localStorage.getItem(TOKEN_KEY),
};